import algoliasearch from 'algoliasearch/lite'
const client = algoliasearch('23PDX9M3ET', '62d446fca7ac9c97644552b75e379a26')

export default client
